import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

interface DashboardCredentialsProps {
  credential: any;
  onDetails: (activeCredential: any) => void;
  id: any;
  image: any;
}

export default function DashboardCredentials(props: DashboardCredentialsProps) {
  const [isPublic, setPublic] = useState(false);
  let credential = props.credential.credential;
  let version = props.credential.version;

  const navigate = useNavigate();

  function cardClickHandler() {    
    props.onDetails(props.credential);
    navigate("/details");
  }

  return (
    <>
      <div className="explorer-card-wrap">
        <div
          className="explorer-card"
          style={{
            backgroundImage: `url(../../img/` + props.image + `)`,
          }}
          onClick={cardClickHandler}
        >
          <div className="container">
            <p className="item subtitle">{props.credential.credential_type}</p>
            <p className="item title">{credential.credentialIdentifier}</p>
            {/* <p className="item subtitle">{credential.credentialIdentifier}</p>
            <p className="item title"></p> */}
            <div className="item">
              <p>Version: {props.credential.version}</p>
              {credential.expirationDate ? (
                <p>Expires: {credential.expirationDate.split("T")[0]}</p>
              ) : (
                credential.issuanceDate && (
                  <p>Valid from: {credential.issuanceDate.split("T")[0]}</p>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
